module.exports = sana["lib"]["isomorphic-style-loader"];